import { Button, Card, Input, Form } from 'antd';
import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/react-hooks';
import { API_KEY } from '../../constants';
import axios from 'axios';
import firebase from 'firebase/app';
import { notificationService } from '../ui/NotificationService';
import LoadingSpinner from '../../utils/LoadingSpinner';

export const GET_PROFESOR_KEY = gql`
	query GetMonitor($password: String!) {
		profesores(where: { password: { _eq: $password } }) {
			key
			firebase_uid
			nombre
			active
		}
	}
`;

const SignInProfesor = () => {
	const [isLoading, setIsLoading] = React.useState(false);
	const [getProfesor] = useLazyQuery(GET_PROFESOR_KEY, {
		onCompleted: ev => {
			if (ev.profesores.length > 0 && ev.profesores[0].active) {
				axios
					.post(`${API_KEY}/auth/signInProfessor`, {
						login: {
							uid: ev.profesores[0].firebase_uid,
							hasuraKey: ev.profesores[0].key,
							tipoUsuario: 'profesor'
						}
					})
					.then(res => {
						firebase
							.auth()
							.signInWithCustomToken(res.data.token)
							.catch(function(error: any) {
								setIsLoading(false);
								return error;
							});
						setIsLoading(false);
					});
			} else {
				notificationService({ error: true }, 'Contraseña incorrecta, intenta de nuevo');
			}
		}
	});

	if (isLoading) {
		return <LoadingSpinner type="pacman"></LoadingSpinner>;
	}

	return (
		<Card title="Profesor" style={{ width: '100%' }}>
			<Form
				name="basic"
				initialValues={{ remember: true }}
				onFinish={values => {
					setIsLoading(true);
					getProfesor({ variables: { password: values.password } });
				}}
				onFinishFailed={er => {
					setIsLoading(false);
					notificationService({ error: true }, 'Contraseña incorrect, intenta de nuevo');
				}}
			>
				<Form.Item
					label="Password"
					name="password"
					rules={[{ required: true, message: 'Please input your password!' }]}
				>
					<Input.Password autoComplete="on" />
				</Form.Item>

				<Form.Item>
					<Button type="primary" htmlType="submit">
						Submit
					</Button>
				</Form.Item>
			</Form>
		</Card>
	);
};

export default SignInProfesor;
